/* src/app/components/modal-info/modal-info.component.scss */
:host {
  background: #0d1117;
  display: block;
  height: 100%;
}
.deinstag-header {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 1rem;
  margin-bottom: 16px;
  background-color: #1c1c1e;
}
.deinstag-header .step {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
}
.deinstag-header .step ion-icon {
  font-size: 2rem;
  margin-bottom: 0.5rem;
}
.deinstag-header .step span {
  font-size: 0.8rem;
}
app-modal-info {
  height: 100vh;
  position: relative;
  display: block;
  overflow: hidden;
}
.slide-col {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  background: #0d1117;
}
.slide-col .image-full-screen {
  display: none;
}
.back_btn_close {
  position: absolute;
  top: 10px;
  right: 15px;
  margin: 0px;
  background: transparent;
  width: 15px;
  height: 15px;
  padding: 0px;
  z-index: 99;
  cursor: pointer;
}
.back_btn_close ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.header-wrapper {
  position: sticky;
  top: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0;
  padding-top: max(env(safe-area-inset-top), 0px);
  align-items: center;
  background: #0d1117;
  z-index: 100;
  flex-shrink: 0;
}
@supports not (position: sticky) {
  .header-wrapper {
    position: -webkit-sticky;
    position: fixed;
    left: 0;
    right: 0;
  }
}
.header-wrapper .back_btn {
  width: 30px;
  height: 30px;
}
.content-scrollable-area {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  background: #0d1117;
  position: relative;
  z-index: 1;
}
.option-group-col {
  padding: 15px 10px;
  display: flex;
  flex-direction: column;
}
.option-group-col.hidden {
  max-height: 0px;
  display: none;
}
.last-item {
  height: 75px;
}
.grow {
  flex-grow: 1;
  overflow: auto;
}
.back-img {
  position: absolute;
  top: 30px;
  left: 30px;
}
.image-wrapper {
  height: 33vh;
  flex-shrink: 0;
  position: relative;
}
.image-wrapper .category-background {
  position: absolute;
  z-index: 1;
  display: block;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100vw;
  height: 100%;
  font-size: 30vw;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  text-transform: uppercase;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.image-wrapper .back_icon {
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 99;
  zoom: 1.5;
}
.image-wrapper .cross_icon {
  z-index: 99;
  position: absolute;
  right: 10px;
  top: 10px;
  zoom: 1.5;
}
.main-img {
  height: 15vh;
  width: 100%;
  object-fit: cover;
  margin: 1px auto 0;
  z-index: 2;
}
@media (max-width: 992px) {
  .main-img {
    height: 31vh;
  }
}
@media (min-width: 991px) {
  .main-img {
    height: 100%;
  }
}
.no-img {
  height: 15vh;
  width: 85%;
  margin: 0 auto 0px;
  z-index: 2;
  flex-shrink: 0;
}
.no-img-wrapper {
  height: 15vh !important;
}
.default-img {
  height: 15vh;
  width: 100px !important;
}
.info {
  padding: 0 20px 0px 20px;
  flex-shrink: 0;
}
.info .title {
  font-size: 22px;
  line-height: 110%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: #fff;
}
.info .title .info_block {
  font-size: 17px;
  margin-left: 5px;
  cursor: pointer;
  margin-bottom: 4px;
}
.info .desc {
  font-size: 16px;
  line-height: 130%;
  margin-bottom: 20px;
  color: #D6D6D6;
}
.info .ingrediants-section {
  display: flex;
  justify-content: flex-end;
  padding: 10px 0px;
  align-items: center;
  width: 100%;
}
.info .ingrediants-section h3 {
  text-align: left;
  font-size: 18px;
  line-height: var(--modal-info-desc-line-height);
  padding-bottom: 10px;
  color: #fff;
}
.info .ingrediants-section p {
  cursor: pointer;
  text-align: left;
  font-size: 16px;
  color: #fff;
  line-height: var(--modal-info-desc-line-height);
  padding-bottom: 10px;
  text-decoration: underline;
}
@media (max-width: 992px) {
  .info .ingrediants-section p {
    width: 50%;
    text-align: right;
  }
}
.menge {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.menge h5 {
  font-size: 18px;
  text-transform: uppercase;
}
.menge {
  margin: 0px 20px 20px;
}
ion-button {
  position: relative;
}
ion-button .buuton-text {
  font-size: var(--modal-info-button-font-size);
  color: var(--color-black);
  margin-right: 0;
}
ion-button .button-icon {
  position: absolute;
  right: 5px;
  height: 34px;
  width: 34px;
}
ion-toolbar {
  height: 60px;
  display: flex;
  align-items: center;
  --background: var(--background-color);
}
ion-toolbar ion-title {
  font-weight: 100;
  padding-inline: unset !important;
  font-size: 16px;
  text-align: left;
  margin-left: 40px;
}
ion-toolbar ion-button {
  --background: transparent;
  --background-activated: transparent;
  --background-focused: transparent;
  --background-hover: transparent;
}
ion-toolbar ion-icon {
  padding: 8px;
  font-size: 15px;
}
ion-page {
  background: transparent;
}
.slider-select-half {
  height: 100%;
  width: 100%;
}
.separator {
  height: 14px;
  width: 100%;
}
.allergens {
  margin: 5px 20px;
}
.allergens app-accordion-list {
  width: 100%;
}
.padding-block {
  padding: 0px 20px;
}
.vertical-line {
  content: " ";
  width: 1px;
  height: 20px;
  color: white;
  background: white;
  margin-inline: 10px;
}
.add-background {
  background-size: cover;
}
.button-footer-block {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0px !important;
  margin-top: auto !important;
  padding: 10px 12px;
  padding-bottom: max(10px + env(safe-area-inset-bottom), 10px);
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
  font-size: 14px;
  border-top: 1px solid #383838;
  background: #0d1117;
  z-index: 100;
  flex-shrink: 0;
}
@supports not (position: sticky) {
  .button-footer-block {
    position: -webkit-sticky;
    position: fixed;
  }
}
@media (max-width: 360px) {
  .button-footer-block {
    padding: 8px 10px;
    padding-bottom: max(8px + env(safe-area-inset-bottom), 8px);
    gap: 6px;
  }
}
.button-footer-block .quantity-row {
  width: auto;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.button-footer-block .quantity-row .quantity-selector-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: #383838;
  border: 1px solid #fff;
  border-radius: 20.5px;
  padding: 0 16px;
  height: 41px;
  width: 135px;
}
@media (max-width: 360px) {
  .button-footer-block .quantity-row .quantity-selector-main {
    gap: 12px;
    padding: 0 12px;
    width: 120px;
    height: 38px;
  }
}
.button-footer-block .quantity-row .quantity-selector-main .quantity-btn {
  width: 18px;
  height: 18px;
  cursor: pointer;
  transition: transform 0.2s, opacity 0.2s;
  flex-shrink: 0;
}
@media (max-width: 360px) {
  .button-footer-block .quantity-row .quantity-selector-main .quantity-btn {
    width: 16px;
    height: 16px;
  }
}
.button-footer-block .quantity-row .quantity-selector-main .quantity-btn:hover {
  transform: scale(1.2);
}
.button-footer-block .quantity-row .quantity-selector-main .quantity-btn:active {
  transform: scale(0.9);
}
.button-footer-block .quantity-row .quantity-selector-main .quantity-btn.disabled {
  opacity: 0.3;
  cursor: not-allowed;
  pointer-events: none;
}
.button-footer-block .quantity-row .quantity-selector-main .quantity-text {
  font-size: 16px;
  color: #fff;
  min-width: 24px;
  text-align: center;
}
@media (max-width: 360px) {
  .button-footer-block .quantity-row .quantity-selector-main .quantity-text {
    font-size: 14px;
    min-width: 20px;
  }
}
@media (min-width: 991px) {
  .button-footer-block .quantity-row .quantity-selector-main .quantity-text {
    font-size: 18px;
    min-width: 28px;
  }
}
.button-footer-block .button-checkout {
  flex: 1;
  min-width: 0;
  max-width: 207px;
  height: 41px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--ion-color-primary);
  border-radius: 20.5px;
  border: none;
  cursor: pointer;
  position: relative;
  padding: 0 20px;
  transition: background 0.3s ease;
}
@media (max-width: 360px) {
  .button-footer-block .button-checkout {
    height: 38px;
    padding: 0 16px;
  }
}
@media (min-width: 991px) {
  .button-footer-block .button-checkout {
    height: 45px;
    max-width: 240px;
    padding: 0 24px;
  }
}
.button-footer-block .button-checkout:hover {
  background: var(--ion-color-primary-tint);
}
.button-footer-block .button-checkout.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.button-footer-block .button-checkout .checkout-text {
  font-size: 13px;
  line-height: 120%;
  letter-spacing: 0.01em;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--color-white);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}
@media (max-width: 385px) {
  .button-footer-block .button-checkout .checkout-text {
    font-size: 11px;
    letter-spacing: 0;
  }
}
@media (max-width: 314px) {
  .button-footer-block .button-checkout .checkout-text {
    font-size: 10px;
    letter-spacing: 0;
  }
}
@media (min-width: 991px) {
  .button-footer-block .button-checkout .checkout-text {
    font-size: 15px;
    letter-spacing: 0.02em;
  }
}
.button-footer-block .button-checkout .option-total-quantity {
  position: absolute;
  top: -8px;
  right: -8px;
  height: 24px;
  width: 24px;
  border: 2px solid #000000;
  border-radius: 50%;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  letter-spacing: 0.08em;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: #000;
}
.center-element {
  display: flex;
  align-items: center;
  justify-content: center;
}
.style-block {
  height: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  min-height: 0;
}
@keyframes pulseColor {
  0% {
    color: var(--ion-color-primary);
  }
  30% {
    color: var(--color-black);
  }
  60% {
    color: var(--ion-color-primary);
  }
  100% {
    color: var(--color-black);
  }
}
.show-option-groups {
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
}
.show-option-groups h1 {
  text-transform: uppercase;
  padding: 10px 20px;
}
.show-option-groups.error-item h1 {
  color: var(--color-black);
  animation: pulseColor 4s infinite alternate;
  text-transform: uppercase;
}
.show-option-groups ion-icon {
  transition: rotate 0.3s ease-in-out;
  margin-right: 20px;
  width: 15px;
  height: 15px;
}
.show-option-groups ion-icon.isOpen {
  rotate: 180deg;
}
.delete-option {
  position: absolute;
  bottom: -1px;
  right: 0%;
  z-index: 99;
  color: black;
  background: white;
  border-top-left-radius: 15px;
  text-align: center;
  padding: 7px;
  border-top: 2px dotted black;
  border-left: 2px dotted black;
}
.delete-option p {
  font-size: 13px;
  text-transform: uppercase;
  color: var(--ion-color-primary);
}
.vegan-block {
  display: flex;
  align-items: center;
}
.vegan-block ion-img {
  width: 35px;
  height: 24px;
}
.vegan-block p {
  text-transform: capitalize;
  margin-right: 5px;
  font-size: 12px;
  color: var(--ion-color-secondary);
}
.input-notes {
  padding: 20px;
}
.input-notes ion-item {
  border-bottom: 1px dashed var(--ion-color-primary);
  --background: transparent;
  margin-bottom: 10px;
  margin-top: 0px;
  --padding-start: 0px;
}
.input-notes ion-item ion-input {
  font-size: 14px;
  line-height: 90%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: uppercase;
  color: #fff;
}
.input-notes .container {
  position: relative;
}
.input-notes .container ion-label {
  font-size: 11px;
  line-height: 85%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: capitalize;
  color: #fff;
}
.stacked {
  color: #fff;
}
.filters {
  width: 100%;
}
.filters app-menu-list-filters {
  width: 100%;
}
.text-block {
  margin-bottom: auto;
  margin-top: auto;
}
.price-row {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.price-row .price {
  font-size: 24px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: #fff;
}
.price-row .kcall {
  position: relative;
  color: #fff;
  font-size: 14px;
  line-height: 16.8px;
  letter-spacing: 0%;
  text-align: center;
  text-transform: uppercase;
}
.price-row .kcall,
.price-row .tags {
  position: relative;
  height: 17px;
  margin-left: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.price-row .kcall ion-icon,
.price-row .tags ion-icon {
  width: 20px;
  height: 20px;
}
.price-row .kcall::before,
.price-row .tags::before {
  content: "";
  position: absolute;
  left: -6px;
  width: 1.5px;
  height: 100%;
  background: rgba(255, 255, 255, 0.3);
}
.opt-desc-row {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
}
.opt-desc-row .option-group-limit {
  height: 100%;
  width: fit-content;
  position: absolute;
  left: 4%;
  top: 50%;
  transform: translate(0, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: uppercase;
}
.opt-desc-row .option-group-description {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  font-size: 18px;
  line-height: 120%;
  letter-spacing: 0%;
  text-transform: uppercase;
  color: #fff;
  padding: 0;
}
@media (max-width: 992px) {
  .opt-desc-row .option-group-description {
    font-size: 16px;
    gap: 12px;
  }
}
.opt-desc-row .option-group-description .option-text {
  white-space: nowrap;
  flex-shrink: 0;
}
.opt-desc-row .option-group-description .option-divider {
  flex-grow: 1;
  height: 2px;
  background: #fff;
  min-width: 30px;
}
.opt-desc-row .option-group-description .option-limit-badge {
  font-size: 14px;
  opacity: 0.8;
  font-weight: normal;
  white-space: nowrap;
  flex-shrink: 0;
}
ion-textarea.custom {
  --border-width: 0;
}
.header-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.product-name {
  display: flex;
  align-items: center;
  gap: 5px;
}
.venue_info_block {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #383838;
  padding: 15px 18px;
  margin: 0;
}
.header-logo {
  height: 21px;
  width: 141.32px;
}
.back-icon {
  width: 22px;
  height: 22px;
}
/*# sourceMappingURL=modal-info.component.css.map */
